import globalsApi from '../../api/Globals';

// initial state
const stateIn = {
    globals:
    {
        groupId: 0,
    },
    menuActive: false,
    messages: [],
    loginResponse: false,
    translation: {},
    langInitialized: false,
    modalAlert: false,
    componentProps: {},
};

// getters
const getters = {
    globals: (state) => state.globals,
    menuActive: (state) => state.menuActive,
    messages: (state) => state.messages,
    loginResponse: (state) => state.loginResponse,
    translation: (state) => state.translation,
    langInitialized: (state) => state.langInitialized,
    modalAlert: (state) => state.modalAlert,
    componentProps: (state) => state.componentProps,
};

// actions
const actions = {
    async getGlobals({ commit })
    {
        const globals = await globalsApi.getGlobals();
        const componentProps = await globalsApi.getComponentProps();

        commit('receiveGlobals', globals);
        commit('receiveComponentProps', componentProps.data);
    },
    async fetchLanguage(context, data)
    {
        const translation = await globalsApi.fetchLanguage(data);
        context.commit('receiveLanguage',
            {
                translation,
            });
    },
    async login(context, data)
    {
        try
        {
            const loginResponse = await globalsApi.login(data);
            context.commit('loginResponse',
                {
                    loginResponse,
                });

            const globals = await globalsApi.getGlobals();
            const componentProps = await globalsApi.getComponentProps();

            context.commit('receiveGlobals', globals);
            context.commit('receiveComponentProps', componentProps.data);

            return loginResponse;
        }
        catch (error)
        {
            console.error(error);
            return error;
        }
    },
    async logout({ commit })
    {
        await globalsApi.logout();

        const globals = await globalsApi.getGlobals();
        commit('receiveGlobals', globals);
    },
};

// mutations
const mutations = {
    receiveGlobals(state, globals)
    {
        state.globals = globals;
    },
    receiveComponentProps(state, props)
    {
        state.componentProps = props;
    },
    receiveLanguage(state, { translation })
    {
        state.langInitialized = true;
        state.translation = translation;
    },
    loginResponse(state, { loginResponse })
    {
        state.loginResponse = loginResponse;
    },
    setModalAlert(state, modalAlert)
    {
        state.modalAlert = modalAlert;
    },
    toggleMenu(state)
    {
        state.menuActive = !state.menuActive;
    },
};

export default
{
    state: stateIn,
    getters,
    actions,
    mutations,
};
